import { Activity } from './types';

export const exportTranscript = (activities: Activity[]) => {
    let text = '';

    for (const activity of activities) {
        const hasText = activity?.value?.displayText || activity?.text;
        const attachment =
            activity?.attachments && activity?.attachments?.length
                ? activity.attachments[0]
                : null;
        const isEvent = activity?.type === 'event' && activity?.value;

        if (activity.from.role === 'user' && hasText) {
            text += '#me\n';
            text += (activity?.value?.displayText || activity.text) + '\n';
            text += '\n';
        } else if (hasText) {
            text += '#bot\n';
            text += (activity?.value?.displayText || activity.text) + '\n';
            if (attachment) {
                text +=
                    'JSON_PATH $.attachments[0].contentType | ' +
                    attachment.contentType +
                    '\n';
                text = getJsonPathValues(
                    attachment.content,
                    'JSON_PATH $.attachments[0].content',
                    text
                );
            }
            text += '\n';
        } else if (attachment && !hasText) {
            text += '#bot\n';
            text +=
                'JSON_PATH $.attachments[0].contentType | ' +
                attachment.contentType +
                '\n';
            text = getJsonPathValues(
                attachment.content,
                'JSON_PATH $.attachments[0].content',
                text
            );
            text += '\n';
        } else if (isEvent) {
            text += '#bot\n';
            text += 'JSON_PATH $.name | ' + activity.name + '\n';
            text = getJsonPathValues(activity.value, 'JSON_PATH $.value', text);
            text += '\n';
        }
    }

    const element = document.createElement('a');
    element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
    );
    element.setAttribute('download', 'botium.convo.txt');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

function getJsonPathValues(value: any, path: string, text: string) {
    if (!value) {
        return text;
    }

    if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
            text = getJsonPathValues(value[i], path + `[${i}]`, text);
        }
    } else if (typeof value === 'object') {
        const keys = Object.keys(value);
        for (const key of keys) {
            if (key.indexOf('$') >= 0) {
                continue;
            }
            text = getJsonPathValues(value[key], path + `.${key}`, text);
        }
    } else if (
        value &&
        (typeof value === 'string' || typeof value === 'number')
    ) {
        text += path + ' | ' + value + '\n';
    }
    return text;
}
